import { useMutation, useQueryClient } from 'react-query';
import { CustomerCalendarApi } from '../../CustomerCalendarApi';
import { CustomerBookingsQueryKey, UnbookedOrdersQueryKey } from '../../queryKeys';
import { CustomerBooking } from '../../types';

export function useCancelBookingMutation() {
    const queryClient = useQueryClient();

    return useMutation<unknown, unknown, CustomerBooking>(
        (booking) =>
            booking.kind === 'styling'
                ? CustomerCalendarApi.cancelStylingBooking(booking.calendarItemId)
                : CustomerCalendarApi.cancelPhotoBooking(booking.calendarItemId),
        {
            onSuccess: () => {
                queryClient.invalidateQueries([CustomerBookingsQueryKey]);
                queryClient.invalidateQueries([UnbookedOrdersQueryKey]);
            }
        }
    );
}
